import { render } from "./BundlingPrimaryProduct.vue?vue&type=template&id=231d784a&scoped=true"
import script from "./BundlingPrimaryProduct.vue?vue&type=script&lang=js"
export * from "./BundlingPrimaryProduct.vue?vue&type=script&lang=js"

import "./BundlingPrimaryProduct.vue?vue&type=style&index=0&id=231d784a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231d784a"]])

export default __exports__